import React from "react"
import { useSprings, animated, to } from "react-spring"
import styled from "styled-components"
import card from "./card.png"

const Wrap = styled.div`
  position: fixed;
  overflow: hidden;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  /* -webkit-transform: translateZ(0); */

  div {
    position: absolute;
    width: 100vw;
    height: 100vh;
    will-change: transform;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 0%;

    @media screen and (max-height: 900px) {
      padding-top: 0%;
    }
  }
`

const Card = styled(animated.div)`
  background-color: white;
  background-size: auto 85%;
  background-repeat: no-repeat;
  background-position: center center;
  width: 35vh !important;
  max-width: 300px;
  height: 50vh !important;
  max-height: 450px;
  will-change: transform;
  border-radius: 10px;
  box-shadow: 0 12.5px 100px -10px rgba(50, 50, 73, 0.4),
    0 10px 10px -10px rgba(50, 50, 73, 0.3);
`

const Placeholder = styled.div`
  height: 450px;
`

const cards = [card, card, card, card, card, card]

// These two are just helpers, they curate spring data, values that are later being interpolated into css
const too = i => ({
  x: 0,
  y: i * -4,
  scale: 1,
  rot: -10 + Math.random() * 20,
  delay: i * 100,
})
const from = i => ({ x: 0, rot: 0, scale: 1.5, y: -1000 })
// This is being used down there in the view, it interpolates rotation and scale into a css transform
const trans = (r, s) =>
  `perspective(1500px) rotateX(30deg) rotateY(${
    r / 10
  }deg) rotateZ(${r}deg) scale(${s})`

function FallingCards() {
  const [props] = useSprings(cards.length, i => ({ ...too(i), from: from(i) })) // Create a bunch of springs using the helpers above

  return (
    <>
      <Placeholder />
      <Wrap>
        {props.map(({ x, y, rot, scale }, i) => (
          <animated.div
            key={i}
            style={{
              transform: to([x, y], (x, y) => `translate3d(${x}px,${y}px,0)`),
            }}
          >
            <Card
              style={{
                transform: to([rot, scale], trans),
                backgroundImage: `url(${cards[i]})`,
              }}
            />
          </animated.div>
        ))}
      </Wrap>
    </>
  )
}

export default FallingCards
